import {StateDeclaration} from '@uirouter/core'

const loginCallbackState = {
  name: 'login-callback',
  url: '/login/callback',
  component: null,
} as StateDeclaration

export default loginCallbackState
